import React from "react";
import { useTranslation } from "react-i18next";
import { faqs, heroImages } from "../data/mock";
import { useFaqs } from "../i18n/content";
import { PageHero, Reveal, CTASection } from "../components/common";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import Seo from "../components/Seo";

const FAQ = () => {
  const { t } = useTranslation();
  const items = useFaqs();
  return (
    <>
      <Seo
        title="Fishing Charter FAQ — San Juan del Sur, Nicaragua | Hog Tide"
        description="Answers to common questions about Hog Tide fishing charters in San Juan del Sur, Nicaragua — seasons, species, what's included, group size and booking."
        path="/faq"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
      />
      <PageHero image={heroImages[3].img} eyebrow={t("faq.eyebrow")} title={t("faq.title")} sub={t("faq.sub")} />
      <section className="py-14">
        <div className="container-x max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-3">
              {items.map((f, i) => (
                <AccordionItem key={i} value={`i${i}`} className="rounded-xl border border-white/10 bg-[#0e2740] px-5">
                  <AccordionTrigger className="text-left font-heading text-lg text-white hover:no-underline hover:text-[#f5a524]">{f.q}</AccordionTrigger>
                  <AccordionContent className="text-slate-300 text-sm leading-relaxed">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
      <CTASection image={heroImages[0].img} />
    </>
  );
};

export default FAQ;
